import categoryFlairMixin from '../flairs/category-flairs-mixin';
import servicesFlairMixin from '../flairs/services-flairs-mixin';
import priceFlairMixin from '../flairs/price-flairs-mixin';
import featuresFlairMixin from '../flairs/features-flairs-mixin';

async function saveCurrentSearchResults() {
    if (typeof window === "undefined") {
        return;
    }

    this.loadingSave = true;

    const url = _.get(window, 'location.pathname', '') + _.get(window, 'location.hash', '');

    const cleanLocation = _.cloneDeep(this.location);
    delete cleanLocation.description;
    delete cleanLocation.breadcrumbs;
    delete cleanLocation.publicCategories;

    const payload = {
        url,
        filters: JSON.stringify(
            {
                location: cleanLocation,
                price: this.price,
                features: this.features,
                services: this.services,
                category: this.category,
                searchRadius: this.searchRadius,
            }
        )
    }

    const [err, response] = await to(
        api.user.saved_searches.save(payload)
    )

    this.loadingSave = false;

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    const filters = _.get(response, 'data.savedSearch.filters', {});
    this.selectedFiltersText = this.parseSavedSearchFiltersToString(filters);
    this.selectedLocationText = this.parseLocationAndRadiusFromFilters(filters);
}

function parseSavedSearchFiltersToString(filters) {
    const categoryText = this.getFlairCategoryTextMobileWithoutDefaults(filters.category);
    const servicesText = this.getFlairServiceTextMobile(filters.services);
    const priceText = this.getFlairPriceText(filters.price);
    const featuresText = this.getFlairFeaturesTextMobile(filters.features);

    const joinedText = _.compact([priceText, featuresText, servicesText, categoryText]).join(', ');
    return _.replace(joinedText, /,(\s+,)+/g, ',');
}

function parseLocationAndRadiusFromFilters(filters) {
    const location = _.get(filters, 'location.locale_name');
    const radius = _.get(filters, 'searchRadius', '20km')
    return location + ' ' + radius;
}

async function getSavedSearches() {
    this.loadingList = true;

    const [err, response] = await to(
        api.user.saved_searches.get()
    )

    this.loadingList = false;

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.savedSearches = _.get(response, 'data.savedSearches', []);
}

async function deleteSavedSearch(id) {
    const [err, response] = await to(
        api.user.saved_searches.delete(id)
    )

    if (err || _.get(response, 'data.success') !== true) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.savedSearches = _.filter(this.savedSearches, search => search.id !== id);
}

async function getSavedSearchUpdates() {
    const [err, response] = await to(
        api.user.saved_searches.updates()
    )

    if (err) {
        toastr.error(this.translate.home.errorCommon);
    }

    return _.get(response, 'data', []);
}

async function fetchSavedSearchUpdatesCount() {
    const updates = await this.getSavedSearchUpdates();

    this.savedSearchNewResultsCount = updates
        .map(u => u.newResultsCount)
        .reduce((a, b) => {
            return a + b
        }, 0);
}

export default {
    data() {
        return {
            selectedFiltersText: '',
            selectedLocationText: '',
            savedSearches: [],
            loadingList: true,
            loadingSave: true,
            savedSearchNewResultsCount: 0,
        }
    },
    computed: {
        ...mapState([
            'translate',
            'currentUser',
            'location',
            'price',
            'features',
            'settings',
            'services',
            'category',
            'searchRadius',
        ]),
    },
    mixins: [
        categoryFlairMixin,
        servicesFlairMixin,
        priceFlairMixin,
        featuresFlairMixin,
    ],
    methods: {
        saveCurrentSearchResults,
        parseSavedSearchFiltersToString,
        parseLocationAndRadiusFromFilters,
        getSavedSearches,
        deleteSavedSearch,
        getSavedSearchUpdates,
        fetchSavedSearchUpdatesCount,
    }
}
